import * as z from "zod";

export const createAdvancedFlowFromDefault = {
  name: "createAdvancedFlowFromDefault" as const,
  input: z.object({ defaultFlowId: z.string() }),
  output: z.object({ id: z.string() }),
};
